import $ from 'jquery'
import Behaviors from './../behaviors'
import debounce from 'debounce'

export default class cannabisSchengenHealthDepartmentSearch {
    constructor (element) {
        console.log('cannabisSchengenHealthDepartmentSearch')
        this.$element = $(element)
        this.$form = this.$element.closest('form')

        this.searchUri = this.$element.data('searchUri')
        this.searchButtonSelector = this.$element.data('searchButtonSelector')
        this.resultContainerSelector = this.$element.data('resultContainerSelector')
        this.searchFieldSelector = this.$element.data('searchFieldSelector')

        this.$searchButton = this.$element.find(this.searchButtonSelector)
        this.$resultContainer = this.$element.find(this.resultContainerSelector)

        this.$searchField = this.$element.find(this.searchFieldSelector)
        this.$searchSpinner = this.$element.find('.loadingSpinner')
        this.$searchButton.on('click', this.handleButtonClick.bind(this))
        this.$searchField.on('keyup', debounce(async (event) => {
            this.handleSearchChangeDebounced(event)
        }, 500).bind(this))
        this.loadInProgress = false
    }

    handleButtonClick (event) {
        event.preventDefault()
        this.search()
    }

    handleSearchChangeDebounced (event) {
        if (this.$searchField.val().length > 2) {
            this.search()
        }
    }

    search () {
        if (this.loadInProgress) {
            return
        }
        this.loadInProgress = true

        Behaviors.detachBehaviors(this.$resultContainer.get(0))
        this.$resultContainer.empty()
        this.$searchSpinner.removeClass('d-none')

        const searchTerm = this.$searchField.val()
        const ajaxSettings = {
            url: this.searchUri,
            method: 'POST',
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({ 'search': searchTerm }),
            headers: {}
        }

        this.searchXHR = $.ajax(ajaxSettings)
            .done(this.handleRequestDone.bind(this))
            .fail(this.handleRequestFail.bind(this))
            .always(() => {
                this.loadInProgress = false
                this.$searchSpinner.addClass('d-none')
            })
    }

    handleResponse (status, response) {
        if (status !== 200) {
            return
        }

        this.$resultContainer.html(response.result)
        this.$resultContainer.show()
        Behaviors.attachBehaviors(this.$resultContainer.parent().get(0))
    }

    handleRequestDone (data, textStatus, jqXHR) {
        this.handleResponse(jqXHR.status, data, jqXHR.responseText)
    }

    handleRequestFail (jqXHR, textStatus, errorThrown) {
        let data = {}
        try {
            if (jqXHR.responseText) {
                data = JSON.parse(jqXHR.responseText)
            }
        } catch (e) {
            console.error(jqXHR.responseText)
        }
        this.handleResponse(jqXHR.status, data, jqXHR.responseText)
    }
}
